import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useGlobalName from '@hooks/useGlobalName';
import { MainRecommendedItemRow } from '@models/item/recommendedItem';
import { useTranslation } from 'react-i18next';

interface Props {
    item: MainRecommendedItemRow;
}

function RecommendationText({ item }:Props) {
    const {
        basePrice, salePrice, name, nameJa, nameEn,
    } = item;
    const { t } = useTranslation('main', { keyPrefix: 'recommendation' });
    const itemName = useGlobalName({ nameEn, nameJa, name });
    const priceUnit = usePriceUnit();
    return (
        <Column fullWidth
            align='center' >
            <NameText align='center'>
                {itemName}
            </NameText>
            <Row spacing={3} align='center'>
                {basePrice !== salePrice && (
                    <Text color={colors.gray6} size='s'>
                        {basePrice.toLocaleString()}{priceUnit}
                    </Text>
                )}
                <PriceText fontWeight='bold' size='s' >
                    {salePrice.toLocaleString()} {priceUnit}
                </PriceText>
            </Row>
        </Column>
    );
}

const NameText = styled(Text)`
    max-width: 100%;
    overflow: hidden;
    white-space: wrap;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-word;
    text-overflow: ellipsis;
`;

const PriceText = styled(Text)`
    line-height: 26px;
`;

export default RecommendationText;
